/* ============================================================
   NITTI COLOUR GRID (v4) — JavaScript
   ============================================================
   Grid-only version with precise Minimog sync.

   v4 changes from v3:
   - Targets Minimog's actual visible selects directly:
       * select[name="options[Color]"]     (visible colour dropdown)
       * select[name="id"]                 (master variant id)
     These sit OUTSIDE the cart form in Minimog, so we search
     the whole document.
   - Based on actual DOM inspection of the Nitti store.
   ============================================================ */
(function () {
  'use strict';

  var DEBUG = true;
  function log() {
    if (DEBUG && window.console) {
      console.log.apply(console, ['[NCG]'].concat([].slice.call(arguments)));
    }
  }

  function init(root) {
    if (!root || root.dataset.ncgReady === '1') return;
    root.dataset.ncgReady = '1';

    var variantsScript = root.querySelector('[data-ncg-variants]');
    if (!variantsScript) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (err) {
      console.error('[NCG] Could not parse variant data', err);
      return;
    }

    var selectedNameEl = root.querySelector('[data-ncg-selected-name]');
    var grid           = root.querySelector('[data-ncg-grid]');
    var search         = root.querySelector('[data-ncg-search]');
    var emptyState     = root.querySelector('[data-ncg-empty]');

    if (!grid) return;

    function findVariant(id) {
      id = parseInt(id, 10);
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    function updateSelectedName(variant) {
      if (selectedNameEl && variant) selectedNameEl.textContent = variant.title;
    }

    var currentlySelectedSwatch = null;
    function updateSelectedSwatch(variantId) {
      var newSwatch = grid.querySelector(
        '[data-ncg-swatch][data-variant-id="' + variantId + '"]'
      );
      if (!newSwatch) return;

      if (currentlySelectedSwatch && currentlySelectedSwatch !== newSwatch) {
        currentlySelectedSwatch.classList.remove('is-selected');
        currentlySelectedSwatch.setAttribute('aria-pressed', 'false');
      }

      newSwatch.classList.add('is-selected');
      newSwatch.setAttribute('aria-pressed', 'true');
      currentlySelectedSwatch = newSwatch;
    }

    function fireAllEvents(el) {
      if (!el) return;
      var events = ['input', 'change'];
      for (var i = 0; i < events.length; i++) {
        try {
          el.dispatchEvent(new Event(events[i], { bubbles: true, cancelable: true }));
        } catch (e) {
          var evt = document.createEvent('Event');
          evt.initEvent(events[i], true, true);
          el.dispatchEvent(evt);
        }
      }
    }

    // --------------------------------------------------------
    // Find Minimog's selects. These live OUTSIDE the form,
    // so we search the whole document — but we must exclude
    // elements inside our own wrapper, plus quickview/modals.
    // --------------------------------------------------------
    function findNativeSelects() {
      var result = { idSelect: null, optionSelects: [] };

      // Master variant id select. Minimog uses select[name="id"]
      // with class "m-product-option--dropdown-select".
      var idSelects = document.querySelectorAll('select[name="id"]');
      for (var i = 0; i < idSelects.length; i++) {
        var s = idSelects[i];
        if (s.closest('.ncg-wrapper')) continue;
        if (s.closest('.quickview, .quick-view, .modal, [data-quickview]')) continue;
        result.idSelect = s;
        break;
      }

      // Option selects: name="options[Xxx]"
      var optSelects = document.querySelectorAll('select[name^="options["]');
      for (var j = 0; j < optSelects.length; j++) {
        var os = optSelects[j];
        if (os.closest('.ncg-wrapper')) continue;
        if (os.closest('.quickview, .quick-view, .modal, [data-quickview]')) continue;
        result.optionSelects.push(os);
      }

      return result;
    }

    // --------------------------------------------------------
    // Push a new variant to Minimog's native picker.
    // --------------------------------------------------------
    function syncNativePicker(variant) {
      if (!variant) return;
      var picker = findNativeSelects();
      var optionValues = [variant.option1, variant.option2, variant.option3];

      // 1. Update the visible option <select>s — these are the
      //    dropdowns the shopper actually sees. Minimog's JS
      //    listens to 'change' on these to trigger image swap,
      //    price update, etc.
      for (var i = 0; i < picker.optionSelects.length; i++) {
        var sel = picker.optionSelects[i];
        // Extract the option index from the name: options[Color] -> name match
        // Since we don't know the exact option order, match by value presence.
        var newVal = null;
        for (var oi = 0; oi < optionValues.length; oi++) {
          var val = optionValues[oi];
          if (val == null) continue;
          // Check if this select has an option with this value
          for (var k = 0; k < sel.options.length; k++) {
            if (sel.options[k].value === val) {
              newVal = val;
              break;
            }
          }
          if (newVal) break;
        }
        if (newVal && sel.value !== newVal) {
          sel.value = newVal;
          fireAllEvents(sel);
          log('Updated option select to', newVal, sel);
        }
      }

      // 2. Also update the master id <select> directly.
      //    Minimog keeps this in sync with the option selects,
      //    but we update it too as a safety net.
      if (picker.idSelect && picker.idSelect.value !== String(variant.id)) {
        picker.idSelect.value = String(variant.id);
        fireAllEvents(picker.idSelect);
        log('Updated id select to', variant.id);
      }
// 2b. Update Minimog's sticky Add-to-Cart bar image,
      //     which doesn't auto-sync with variant changes.
      if (variant.featured_image && variant.featured_image.src) {
        var stickyImg = document.querySelector(
          '.m-sticky-addtocart--image img, m-sticky-atc img'
        );
        if (stickyImg) {
          var newSrc = variant.featured_image.src;
          // Replace width param for thumbnail size (sticky bar is small)
          var thumbSrc = newSrc.replace(/(\?|&)width=\d+/, '$1width=120');
          stickyImg.src = thumbSrc;
          // Clear srcset so the browser uses our new src
          if (stickyImg.srcset) stickyImg.srcset = '';
          stickyImg.alt = variant.featured_image.alt || variant.title || '';
        }
      }
      // 3. Dispatch a generic variant:changed for anything else
      try {
        document.dispatchEvent(new CustomEvent('variant:changed', {
          bubbles: true,
          detail: { variant: variant }
        }));
      } catch (e) {}
    }
    function updateMainImageForVariant(variant) {
      if (!variant || !variant.featured_image || !variant.featured_image.src) return;
      var filename = variant.featured_image.src.split('/').pop().split('?')[0];

      var slides = document.querySelectorAll('.swiper-slide.m-product-media--item');
      var match = null;
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (!img) continue;
        var candidates = (img.src || '') + '|' + (img.getAttribute('data-src') || '') +
          '|' + (img.srcset || '') + '|' + (img.getAttribute('data-srcset') || '');
        if (candidates.indexOf(filename) !== -1) { match = slides[i]; break; }
      }
      if (!match) { log('No matching slide found for', filename); return; }

      var index = parseInt(match.dataset.swiperSlideIndex, 10);
      var container = match.closest('.swiper-container');
      var swiper = container && container.swiper;
      if (!swiper) return;

      if (typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(index, 0);
      } else {
        swiper.slideTo(index, 0);
      }
      log('Main image slid to variant image', variant.id, 'index', index);
    }

    // --------------------------------------------------------
    // Reverse sync: listen to the native picker and update grid
    // --------------------------------------------------------
function watchNativePicker() {
      var isSyncing = false;

      document.addEventListener('change', function (e) {
        if (isSyncing) return;
        var el = e.target;
        if (!el || el.tagName !== 'SELECT') return;
        if (el.closest && el.closest('.ncg-wrapper')) return;
        if (el.closest && el.closest('.quickview, .quick-view, .modal, [data-quickview]')) return;

        var isIdSelect = el.name === 'id';
        var isOptionSelect = /^options\[/.test(el.name || '');
        if (!isIdSelect && !isOptionSelect) return;

        // Read the new variant ID directly from the select that just changed.
        // CRITICAL: the mobile sticky Add-to-Cart bar has its own select
        // whose value Minimog does NOT propagate to the main picker, so
        // we must NOT rely on findNativeSelects() — that finds the main
        // picker, which still has the old value at this point.
        var newId = null;
        if (isIdSelect) {
          newId = parseInt(el.value, 10);
        } else if (isOptionSelect) {
          // Single-option yarn products (Color only) — match on option1.
          var newValue = el.value;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].option1 === newValue) {
              newId = variants[i].id;
              break;
            }
          }
        }

        if (!newId) return;
        var variant = findVariant(newId);
        if (!variant) return;

        // Skip if the grid already reflects this variant.
        var currentSel = grid.querySelector('.is-selected');
        var currentId = currentSel ? parseInt(currentSel.dataset.variantId, 10) : null;
        if (newId === currentId) return;

        // Apply the variant everywhere. The isSyncing flag prevents
        // syncNativePicker's dispatched events from re-triggering us.
        isSyncing = true;
        try {
          updateSelectedSwatch(newId);
          updateSelectedName(variant);
          syncNativePicker(variant); // updates other selects, fires events that swap the main image, updates sticky bar thumbnail
          updateMainImageForVariant(variant);
          updateUrl(newId);
        } finally {
          // Clear flag after synthetic events have finished bubbling.
          setTimeout(function () { isSyncing = false; }, 150);
        }

        log('Native picker change → applied variant', newId);
      }, true);
    }

    // --------------------------------------------------------
    // URL sync
    // --------------------------------------------------------
    function updateUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    // --------------------------------------------------------
    // Main: swatch click handler
    // --------------------------------------------------------
    function selectVariant(variantId) {
      var variant = findVariant(variantId);
      if (!variant) return;

      updateSelectedSwatch(variantId);
      updateSelectedName(variant);
      syncNativePicker(variant);
      updateMainImageForVariant(variant);
      updateUrl(variantId);
    }

    grid.addEventListener('click', function (e) {
      var swatch = e.target.closest('[data-ncg-swatch]');
      if (!swatch) return;
      e.preventDefault();
      var id = swatch.dataset.variantId;
      if (id) selectVariant(id);
    });

    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var swatch = e.target.closest('[data-ncg-swatch]');
      if (!swatch) return;
      e.preventDefault();
      var id = swatch.dataset.variantId;
      if (id) selectVariant(id);
    });

    // --------------------------------------------------------
    // Search / filter
    // --------------------------------------------------------
    if (search) {
      var debounceTimer;
      search.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          var query = search.value.trim().toLowerCase();
          var swatches = grid.querySelectorAll('[data-ncg-swatch]');
          var visibleCount = 0;
          for (var i = 0; i < swatches.length; i++) {
            var s = swatches[i];
            var text = s.dataset.searchText || '';
            var match = !query || text.indexOf(query) !== -1;
            s.classList.toggle('is-hidden', !match);
            if (match) visibleCount++;
          }
          if (emptyState) emptyState.hidden = visibleCount > 0;
        }, 80);
      });
    }

    // --------------------------------------------------------
    // Boot
    // --------------------------------------------------------
    watchNativePicker();

   try {
  var urlVariant = new URL(window.location.href).searchParams.get('variant');
  var initialVariant = urlVariant ? findVariant(urlVariant) : null;

  console.log('[NCG-DEBUG] urlVariant from address bar:', urlVariant);
  console.log('[NCG-DEBUG] matched variant object:', initialVariant);

if (initialVariant) {
        updateSelectedSwatch(initialVariant.id);
        updateSelectedName(initialVariant);

        (function waitForSwiperThenUpdate(attemptsLeft) {
          var container = document.querySelector('.swiper-container');
          if (container && container.swiper && container.swiper.slides && container.swiper.slides.length > 1) {
            updateMainImageForVariant(initialVariant);
          } else if (attemptsLeft > 0) {
            setTimeout(function () { waitForSwiperThenUpdate(attemptsLeft - 1); }, 100);
          } else {
            log('Gave up waiting for Swiper to initialize');
          }
        })(20); // retries for up to ~2 seconds
      }
} catch (e) {
  console.log('[NCG-DEBUG] Boot block threw an error:', e);
}
  }

  function bootAll() {
    var roots = document.querySelectorAll('.ncg-wrapper');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target && e.target.querySelector
      ? e.target.querySelector('.ncg-wrapper')
      : null;
    if (target) init(target);
  });
})();
/* ============================================================
   COLLAPSIBLE TABS — Minimog Product information tabs
   ============================================================ */
(function () {
  function initCollapsibleTabs() {
    var tabSection = document.querySelector('.m-product-details-tabs');
    if (!tabSection) return;
    if (tabSection.dataset.ncgCollapsibleReady === '1') return;
    tabSection.dataset.ncgCollapsibleReady = '1';

    var headers  = tabSection.querySelectorAll('.m-tab-header');
    var contents = tabSection.querySelectorAll('.m-tab-content');

    // On load: close everything. Give Minimog a moment to init first.
    setTimeout(function () {
      headers.forEach(function (h) { h.classList.remove('active'); });
      contents.forEach(function (c) { c.classList.remove('active'); });
    }, 50);

    // Find the content that matches a header by data-block-type
    // (headers and contents share this attribute).
    function findContentFor(header, headerIdx) {
      var blockType = header.getAttribute('data-block-type');
      if (blockType) {
        // Find content with matching data-block-type.
        // If there are multiple (e.g. two liquid tabs), fall back to index position.
        var matches = tabSection.querySelectorAll(
          '.m-tab-content[data-block-type="' + blockType + '"]'
        );
        if (matches.length === 1) return matches[0];
        // If multiple, use position among same-type headers
        var sameTypeHeaderCount = 0;
        for (var i = 0; i <= headerIdx; i++) {
          if (headers[i].getAttribute('data-block-type') === blockType) {
            sameTypeHeaderCount++;
          }
        }
        return matches[sameTypeHeaderCount - 1];
      }
      return contents[headerIdx]; // fallback: positional
    }

    headers.forEach(function (header, idx) {
      header.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var isActive = header.classList.contains('active');

        // Close all
        headers.forEach(function (h) { h.classList.remove('active'); });
        contents.forEach(function (c) { c.classList.remove('active'); });

        // Open this one (unless it was the one currently active — then we just closed)
        if (!isActive) {
          header.classList.add('active');
          var matching = findContentFor(header, idx);
          if (matching) matching.classList.add('active');
        }
      }, true); // capture phase
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollapsibleTabs);
  } else {
    initCollapsibleTabs();
  }
  document.addEventListener('shopify:section:load', initCollapsibleTabs);
})();